import { State } from 'src/state/store'
import { User } from './types'

export function isAuthenticatedSelector(state: State): boolean {
  return Boolean(state.authentication?.appTokens?.token) || false
}

export function tokenSelector(state: State): string {
  return state.authentication?.appTokens?.token || ''
}

export function refreshTokenSelector(state: State): string {
  return state.authentication?.appTokens?.refreshToken || ''
}

export function userSelector(state: State): User | null {
  return state.authentication.user
}
